import SupremeGolfApiClient from './SupremeGolfApiClient';

const EVENTUAL_INSURANCE = 'v6/eventual_insurance';
export default class EventualWeatherApi {
  static async getEventualInsuranceDetails(courseId) {
    const response = await SupremeGolfApiClient.get(`${EVENTUAL_INSURANCE}/course/${courseId}`);

    return response.data;
  }

  static async getEventualInsuranceQuote(reservationId, accessToken = '', trackingParams = {}) {
    let payload = {};
    payload.reservationId = reservationId;
    if (accessToken) payload.accessToken = accessToken;
    payload = { ...payload, ...trackingParams.iterableTracking, ...trackingParams.utmParams };

    const response = await SupremeGolfApiClient.post(`${EVENTUAL_INSURANCE}/reservations/${reservationId}/quote`, payload);

    return response.data;
  }

  static async purchaseEventualInsurance(reservationId, params) {
    const {
      accessToken,
      creditCardId,
      creditCardAccessToken,
      quoteId,
      phoneCountryCode,
      phoneNumber,
    } = params || {};

    const payload = { quoteId, phoneCountryCode, phoneNumber };
    payload.reservationId = reservationId;
    if (accessToken) payload.accessToken = accessToken;
    if (creditCardId) payload.creditCardId = creditCardId;
    if (creditCardAccessToken) payload.creditCardAccessToken = creditCardAccessToken;

    const response = await SupremeGolfApiClient.post(`${EVENTUAL_INSURANCE}/reservations/${reservationId}/purchase`, payload);

    return response.data;
  }
}

